export default {
  path: '/about/volunteer',
  component: () => import('@/layouts/VolunteerLayout'),
  children: [
    {
      path: '',
      name: 'volunteer',
      component: () => import('@/views/volunteer/OpportunityList')
    },
    {
      path: 'submit-opportunity',
      name: 'volunteersubmitopportunity',
      component: () => import('@/views/volunteer/OpportunitySubmissionForm')
    }
  ]
}
